import { preventDuplicatedRequest } from "@/utilities/async-for-each";
import BaseProxy from "../../base-proxy";

export default class SubscriptionServiceProxy {
  async getSubscriptionsByIds(input = {}) {
    const { subscriptionIds, companyIds, status, statuses } = input;
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getSubscriptionBackendUrl();
    let query = "";

    if (subscriptionIds) {
      query = subscriptionIds
        .map((id) => {
          return `ids[]=${id}`;
        })
        .join("&");
    } else if (companyIds) {
      query = companyIds
        .map((id) => {
          return `companyIds[]=${id}`;
        })
        .join("&");
    }

    if (statuses) {
      query += "&" + statuses.map((id) => `statuses[]=${id}`).join("&");
    } else if (status) {
      query += `&status=${status}`;
    }

    const endpointUrl = `${backendUrl}/subscriptions?${query}&load[]=service`;

    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }

  async getServicesList(input = {}) {
    return preventDuplicatedRequest("getServicesList", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getSubscriptionBackendUrl();
      let endpointUrl = `${backendUrl}/services?clientType=${baseProxy.getClientType()}`;

      if (input.internalNames) {
        endpointUrl +=
          "&" +
          input.internalNames
            .map((internalName) => {
              return `internalNames[]=${internalName}`;
            })
            .join("&");
      }

      if (input.codes) {
        endpointUrl +=
          "&" +
          input.codes
            .map((code) => {
              return `codes[]=${code}`;
            })
            .join("&");
      }

      if (input.ids) {
        endpointUrl +=
          "&" +
          input.ids
            .map((id) => {
              return `ids[]=${id}`;
            })
            .join("&");
      }
      endpointUrl += "&status=active";
      return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken, null);
    });
  }

  async resolveSubscriptionRequest(input = {}, subscriptionRequestId, data) {
    return preventDuplicatedRequest("resolveSubscriptionRequest", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getSubscriptionBackendUrl();
      let endpointUrl = `${backendUrl}/subscription-requests/${subscriptionRequestId}/resolve`;

      return await baseProxy.putAuthenticatedData(endpointUrl, input.authToken, data);
    });
  }

  async resolveSubscriptionRequestForManualRenewal(input = {}, subscriptionRequestId, data) {
    return preventDuplicatedRequest("resolveSubscriptionRequestForManualRenewal", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getSubscriptionBackendUrl();
      let endpointUrl = `${backendUrl}/subscription-renewal/request/${subscriptionRequestId}/resolve`;

      return await baseProxy.putAuthenticatedData(endpointUrl, input.authToken, data);
    });
  }

  async createSubscriptionRequest(input, data) {
    return preventDuplicatedRequest("createSubscriptionRequest", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getSubscriptionBackendUrl();
      let endpointUrl = `${backendUrl}/subscription-requests`;

      return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, data);
    });
  }

  async prepareManualRenewalSubscriptionRequest(data = {}, input = {}) {
    return preventDuplicatedRequest("prepareManualRenewalSubscriptionRequest", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getSubscriptionBackendUrl();
      let endpointUrl = `${backendUrl}/subscription-renewal/request`;
      return await baseProxy.postAuthenticatedData(endpointUrl, data.authToken, input);
    });
  }

  async processAfterPayment(companyId, input = {}) {
    return preventDuplicatedRequest("processAfterPayment", async () => {
      let baseProxy = new BaseProxy();
      let backendUrl = await baseProxy.getBackendUrl();
      let endpointUrl = `${backendUrl}/companies/${companyId}/apply-for-post-payment`;
      return await baseProxy.putAuthenticatedFormData(endpointUrl, input.authToken, input);
    });
  }
}
